import { getSiteProps } from "@/utils";

const host = typeof window !== "undefined" ? window.location.host : "";
const siteProps = getSiteProps(host);
const mediaUrl = siteProps?.media_url || "media.foundit.in";
export const linkAcccountsContent = [
  {
    name: "facebook",
    heading: "Link Facebook",
    image: "",
    showToggle: true,
    isToggleChecked: false,
  },
  {
    name: "google",
    heading: "Link Google",
    image: `https://${mediaUrl}/trex/search/public/images/google.svg`,
    showToggle: true,
    isToggleChecked: false,
  },
];

export let deactivateAccountRadioDescription: any = {
  others: "Please mention",
  "fakejobs/recruitersaskingformoney":
    'Report the issue via our <a class="text-brand-primary" href="/info/security-center">Security Centre</a>',
  gettingtoomanyemailsfromfoundit:
    'Customize your  <a class="text-brand-primary" href="/seeker/settings?menu=subscriptions&active=manage-subscriptions">Alert Settings</a>',
  "notgettingrelevant/gettingirrelevantjobsfrommonster":
    'Customize your <a class="text-brand-primary" href="/seeker/job-alert-list">Job Alerts</a>',
  notlookingforajobchange:
    'No Issues, you can update your preferences under <a class="text-brand-primary" href="/seeker/settings?menu=account&active=profile-visibility">Settings</a> still keep the profile active.',
};

export const RIO_LOGOUT_PATH = "/rio/logout";
export const DEACTIVATION_QUESTION = "DEACTIVATION_QUESTION";

export const deactivateAccountContent = {
  popupHeading: "Deactivate until next login",
  popupSubheading:
    "This action will cease all communications from foundit and its affiliates. Your profile will be deactivated for 6 months. However, logging in during this period will reactivate your profile.",
  settingsPageHeading: "Deactivate Account",
  settingsPageSubheading: "Temporarily hide your profile from recruiters",
  settingsPageDeactivateCTA: "Temporarily Deactivate Account",
  loadingReasons: "Loading Reasons...",
};
